const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.slickImg();
        this.appSlider();
        this.iconSlider();
    },

    slickImg: function() {
		$(".slider__box").slick({
            autoplay: false,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 2.5,
            rows: 0,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                    breakpoint: 440,
                    settings: {
                      slidesToShow: 1,
                    }
                  }
              ]
		});
	},

    appSlider: function() {
        $(".slides").slick({
            autoplay: false,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
        });
    },

    iconSlider: function() {
        $(".icon-slider__wrapper").slick({
            autoplay: false,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 5,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            centerMode: true,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                    breakpoint: 540,
                    settings: {
                      slidesToShow: 1,
                    }
                  }
              ]
        });
    }
}

export default _this;